import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Form, FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { SelectionModel } from '@angular/cdk/collections';
import { MatTableDataSource } from '@angular/material/table';
import { ZipOperator } from 'rxjs/internal/observable/zip';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialog,
} from '@angular/material/dialog';
import { Fundo, Usuario } from './criar-grupos-de-investimento.model';
import { CriarGruposDeInvestimentoService } from './criar-grupos-de-investimento.service';
import { Grupo, UsuarioId } from './criar-grupos-de-investimento.model';
import { orderBy } from 'lodash';
import { DialogBoxService } from '@app/custom-shared/components/alerts/dialog-box-service';
import { CaceisApiDynamicBusinessError } from '@app/core/services/exception/error-base';
import { CaceisApiDynamicErrorCodes } from '@app/core/services/exception/caceis-exceptions/caceis-business-errors/caceis-api-dynamic-error-codes';
import { CaceisApiErrors } from '@app/core/services/exception/caceis-exceptions/caceis-api-errors/caceis-api-errors';
import { MatSort } from '@angular/material/sort';
import { FeatureService } from '@app/core/services/feature/feature.service';
import { FundService } from '@app/core/services-api/fund.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MatPaginator } from '@angular/material/paginator';

@Component({
  templateUrl: './criar-grupos-de-investimento.component.html',
  styleUrls: ['./criar-grupos-de-investimento.component.scss'],
})
export class CriarGruposDeInvestimentoComponent implements OnInit, OnDestroy {
  destroy$: Subject<boolean> = new Subject<boolean>()

  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  displayedColumnsUsuarios: string[] = [
    'select',
    'name',
    'login',
    'permissionGroup',
    'status',
  ];
  dataSourceUsuarios: any;
  selectionUsuarios = new SelectionModel<Usuario>(true, []);
  displayedColumnsFundos: string[] = ['select', 'code', 'name'];
  dataSourceFundos: any;
  selectionFundos = new SelectionModel<Fundo>(true, []);
  selectedIndex: number = 0;
  fundsComplete = [];
  usersComplete = [];
  optionUsersComplete = [];
  investmentGroupName = '';
  usersSorted: boolean = false;
  fundsSorted: boolean = false;
  form: FormGroup;
  @ViewChild('sortUsers', { static: false }) sortUsers: MatSort;
  @ViewChild('sortFunds', { static: false }) sortFunds: MatSort;
  @ViewChild('paginator') paginator: MatPaginator;
  filterVal: any;

  constructor(
    private _criarGrupoDeInvestimentoService: CriarGruposDeInvestimentoService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<CriarGruposDeInvestimentoComponent>,
    private snackBarService: DialogBoxService,
    private formBuilder: FormBuilder,
    private fundService: FundService,

    private featureService: FeatureService
  ) { }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      name: ['',[ Validators.required, this.notOnlyWhitespace]],
    });
    this.getUsuarios();
    this.getFundos();
  }
  notOnlyWhitespace (control: FormControl) {
    if (!control.value || control.value.trim().length === 0) {
      return { notOnlyWhitespace: true };
    } else {
      return null;
    }
  }


  async getUsuarios() {
    const result = await this._criarGrupoDeInvestimentoService.getUsuarios();
    const users = [...result].filter(
      el =>
        el.status !== 'Inativo'

    );
    this.dataSourceUsuarios = new MatTableDataSource(users)
    // this.dataSourceUsuarios.sort((a, b) => {
    //   return a.name
    //     .toLowerCase()
    //     .normalize('NFD')
    //     .replace(/[^a-zA-Z0-9s]/g, '') >
    //     b.name
    //       .toLowerCase()
    //       .normalize('NFD')
    //       .replace(/[^a-zA-Z0-9s]/g, '')
    //     ? 1
    //     : -1;
    // });


    this.dataSourceUsuarios.sortingDataAccessor = (data, sortHeaderId) =>
      data[sortHeaderId]
        .normalize('NFD')
        .replace(/[^a-zA-Z0-9s]/g, '')
        .toLowerCase();
    this.dataSourceUsuarios.sort = this.sortUsers;
  }

  getFundos() {
    this.fundService.findAll()
      .pipe(
        takeUntil(this.destroy$)).subscribe(result => {
          result = result.map(item => {
            item.code = item.fundCode
            return item
          })
          this.dataSourceFundos = new MatTableDataSource(

            result.sort((a, b) => {
              if (a.code && b.code) {
                return a.code
                  .toLowerCase()
                  .normalize('NFD')
                  .replace(/[^a-zA-Z0-9s]/g, '') >
                  b.code
                    .toLowerCase()
                    .normalize('NFD')
                    .replace(/[^a-zA-Z0-9s]/g, '')
                  ? 1
                  : -1;
              }
            }),
          );

          this.dataSourceFundos.filterPredicate = (data, filter) => {
            if (data.code === null || data.code === undefined) {
              data.code = '';
            }
            if (data.name === null || data.name === undefined) {
              data.name = '';
            }
            return (
              data.code.toLowerCase().includes(filter.toLowerCase()) ||
              data.name.toLowerCase().includes(filter.toLowerCase())
            );
          };

          this.dataSourceFundos.filterPredicate = (data, filter) => {
            if (data.code === null || data.code === undefined) {
              data.code = '';
            }
            if (data.name === null || data.name === undefined) {
              data.name = '';
            }
            return (
              data.code.toLowerCase().includes(filter.toLowerCase()) ||
              data.name.toLowerCase().includes(filter.toLowerCase())
            );
          };

          this.dataSourceFundos.sortingDataAccessor = (data, sortHeaderId) =>
            typeof data[sortHeaderId] === 'string'
              ? data[sortHeaderId]
                .normalize('NFD')
                .replace(/[^a-zA-Z0-9s]/g, '')
                .toLowerCase()
              : data[sortHeaderId];
          this.dataSourceFundos.sort = this.sortFunds;
          this.dataSourceFundos.paginator = this.paginator;
        })



  }

  isAllSelectedUsuarios() {
    const numSelected = this.selectionUsuarios.selected.length;
    const numRows =
      this.dataSourceUsuarios != null ? this.dataSourceUsuarios.data.length : 0;
    return numSelected === numRows;
  }

  masterToggleUsuarios() {
    this.isAllSelectedUsuarios()
      ? this.selectionUsuarios.clear()
      : this.dataSourceUsuarios.data.forEach(row =>
        this.selectionUsuarios.select(row),
      );
  }

  checkboxLabel(row?: Usuario): string {
    if (!row) {
      return `${this.isAllSelectedUsuarios() ? 'select' : 'deselect'} all`;
    }
    return `${this.selectionUsuarios.isSelected(row) ? 'deselect' : 'select'
      } row ${row.login + 1}`;
  }

  applyFilter(event: Event) {
    this.dataSourceUsuarios.filterPredicate = (data, filter) => {
      if (data.name === null || data.name === undefined) {
        data.name = '';
      }
      return data.name.toLocaleLowerCase().includes(filter.toLocaleLowerCase());
    };

    const filterValue = (event.target as HTMLInputElement).value;
    this.filterVal = filterValue
    this.dataSourceUsuarios.filter = filterValue.toLocaleLowerCase();

    this.optionUsersComplete = this.dataSourceUsuarios.filteredData;

    if (filterValue.length > 0 && filterValue.length % 2 == 0) {
      this.usersComplete = this.dataSourceUsuarios.filteredData;
    } else if (filterValue.length == 0) {
      this.usersComplete = [];
    }
  }

  isAllSelectedFundos() {
    const numSelected = this.selectionFundos.selected.length;
    const numRows =
      this.dataSourceFundos != null ? this.dataSourceFundos.data.length : 0;
    return numSelected === numRows;
  }

  masterToggleFundos() {
    if (this.filterVal != "" || this.filterVal != null || this.filterVal != undefined) {
      this.isAllSelectedFundos()
      ? this.selectionFundos.clear()
      : this.dataSourceFundos.filteredData.forEach(row =>
        this.selectionFundos.select(row),
      );
    } else {
      this.isAllSelectedFundos()
        ? this.selectionFundos.clear()
        : this.dataSourceFundos.data.forEach(row =>
          this.selectionFundos.select(row),
        );
    }
  }

  validateButton() {
    if ((
      this.investmentGroupName.length > 0 &&
      this.selectionFundos.hasValue()
    ) && (this.form.valid)) {
      return false;
    }
    return true;
  }
  checkboxLabelFundos(row?: Fundo): string {
    if (!row) {
      return `${this.isAllSelectedFundos() ? 'select' : 'deselect'} all`;
    }
    return `${this.selectionFundos.isSelected(row) ? 'deselect' : 'select'
      } row ${row.code + 1}`;
  }

  applyFilterFundos(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSourceFundos.filter = filterValue.trim().toLowerCase();

    if (filterValue.length > 0 && filterValue.length % 2 == 0) {
      this.fundsComplete = this.dataSourceFundos.filteredData;
    } else if (filterValue.length == 0) {
      this.fundsComplete = [];
    }
  }

  saveGroup() {
    const investimentGroup = new Grupo();
    investimentGroup.name = this.investmentGroupName;
    investimentGroup.funds = this.selectionFundos.selected.map(a => {
      const fundo = new Fundo();
      fundo.code = a.code;
      // fundo.cnpj = a.cnpj;
      // fundo.name = a.name;
      return fundo;
    });
    investimentGroup.users = this.selectionUsuarios.selected.map(a => {
      const usuario = new UsuarioId();
      usuario.id = a.id;
      return usuario;
    });
    let msgInvGroup, msgSaved: string;
    this.featureService.translatorService.getMessage('investmentsGroup').subscribe(val => msgInvGroup = val)
    this.featureService.translatorService.getMessage('wasSaved').subscribe(val => msgSaved = val)

    this._criarGrupoDeInvestimentoService
      .postInvestmentGroup(investimentGroup)
      .then(() => {
        this.snackBarService.snackbarUtil.showSuccess(
          msgInvGroup + ` "${this.investmentGroupName}" ` + msgSaved,
        );
        this.dialogRef.close(investimentGroup);
      })
      .catch(err => {
        console.log("err",err)
        if (err.error.includes('SC0011') ){
          CaceisApiErrors.SC0011.showError();
        } else {
          // CaceisApiErrors.GENERIC_ERROR.showError();
        }
      });
  }

  selectedIndexChange(val: number) {
    this.selectedIndex = val;
  }

  doFechar() {
    let titlepopup, subtitlepopup, cancelpopup, okpopup: string
    this.featureService.translatorService
      .getMessage('titleConfirm').pipe(
        takeUntil(this.destroy$))
      .subscribe(val => {
        titlepopup = val
      })
    this.featureService.translatorService
      .getMessage('subtitleConfirm').pipe(
        takeUntil(this.destroy$))
      .subscribe(val => {
        subtitlepopup = val
      })
    this.featureService.translatorService
      .getMessage('cancelConfirm').pipe(
        takeUntil(this.destroy$))
      .subscribe(val => {
        cancelpopup = val
      })
    this.featureService.translatorService
      .getMessage('okConfirm').pipe(
        takeUntil(this.destroy$))
      .subscribe(val => {
        okpopup = val
      })
    this.snackBarService.confirmBox({
      lblTitle: titlepopup,
      lblSubtitle: subtitlepopup,
      lblCancelButton: cancelpopup,
      lblConfirmButton: okpopup,
      color: ' red',
      onConfirm: () => {
        this.dialogRef.close();
      },
    });
  }

  sortData(column: string) {
    this.usersSorted = !this.usersSorted;

    this.dataSourceFundos.data = this.dataSourceFundos.data.sort((a, b) => {

      switch (column) {
        case 'code': return this.compare(a.code.naturalNormalize(), b.code.naturalNormalize(), this.usersSorted);
        case 'name': return this.compare(a.name.naturalNormalize(), b.name.naturalNormalize(), false);
        // case 'permissionGroup': return this.compare(a.permissionGroup.naturalNormalize(), b.permissionGroup.naturalNormalize(), this.usersSorted);
        // case 'status': return this.compare(a.status.naturalNormalize(), b.status.naturalNormalize(), this.usersSorted);
        default: return 0;
      }
    })
  }

  compare(a, b, isAsc) {
    if (a === null) {
      a = '';
    }

    if (b === null) {
      b = '';
    }
    return (a.toLowerCase().localeCompare(b.toLowerCase()) ? 1 : -1) * (isAsc ? 1 : -1);
  }
  ngOnDestroy(): void {
    this.destroy$.next(true)
    this.destroy$.complete()

  }
}
